

var opts = {
    timeout: 100,
    interval: 50
  };


  var topNav = document.querySelectorAll('.top-nav > li');
  for (var i = 0; i < topNav.length; i++) {
    var currentHover = topNav[i];
    hoverintent(currentHover,
      function() {
        this.className = 'open';
      }, function() {
        this.className = '';
      }).options(opts);
  }




